import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss',
  standalone: false
})
export class PaymentSuccessComponent {
  errorMessage: any;
  processing: boolean = false;
  UUID: any
  subscribetionPlan: any
  check_subscription_plan: any;
  charged_amount: any;
  plan_amount: any;
  remaining_days: any;
  formatted_end_date: any;
  subscription_plan: any;
  is_downgrade: any;
  preview: any;
  loading: boolean = true;
  plan_update: any;
  last4: any;
  isLoading: boolean
  constructor
    (
      private router: Router,
      private dialogRef: MatDialogRef<PaymentSuccessComponent>,
      @Inject(MAT_DIALOG_DATA) data: any,
      private authService: AuthService,
      private userService: UserService,
    ) {
    this.subscribetionPlan = data.SubscriptionPlan;
    this.plan_update = data.plan_update;
    this.errorMessage = data.errorMessage;
    this.check_subscription_plan = data.check_subscription_plan.subscription_plan;
    this.isLoading = true
  }

  ngOnInit() {
    this.authService.token.subscribe((token: any) => {
      this.UUID = token.UUID;
    });

    this.userService.previewPlan(this.subscribetionPlan, this.UUID).subscribe({
      next: (result: any) => {
        this.charged_amount = result.charged_amount;
        this.plan_amount = result.plan_amount;
        this.remaining_days = result.remaining_days;
        this.formatted_end_date = result.formatted_end_date;
        this.subscription_plan = result.subscription_plan;
        this.is_downgrade = result.is_downgrade;
        this.preview = result.preview;
        this.last4 = result.last4;
        this.loading = false;
        this.isLoading = false;
      },
      error: (err) => {
        this.loading = false;
        this.isLoading = false;
        console.log('Error', err);
      }
    });
  }

  Confirm() {
    this.processing = true;
    this.userService.subscribeToPlan(this.subscribetionPlan, this.UUID).subscribe({
      next: (res) => {
        this.processing = false;
        this.dialogRef.close('cancelDialog');
      },
      error: (err) => {
        this.errorMessage = err.error.failure_message || err.error.error;
        console.log('Error', err);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  goToPayment() {
    this.dialogRef.close();
    // yahan apna payment method route daal do
    this.router.navigate(['/payment-methods']);
  }



}
